import { InputBase, TextField } from "@mui/material";
import { IOptionalField } from "@interfaces";
import Dropdown from "../../Cart/CustomDropdown";

interface IOptionalDataFieldProps {
    optionalField: IOptionalField;
    onChange: (value: any) => void;
    value: any | null;
}

export const OptionalDataField = (props: IOptionalDataFieldProps) => {
    const { optionalField, onChange, value } = props;

    switch (optionalField.type) {
        case "text":
            return (
                <TextField
                    placeholder={optionalField.title ?? ''}
                    fullWidth
                    sx={{ fontWeight: "bold" }}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                />
            );

        case "select":
            return (
                <Dropdown
                    options={optionalField.options.map((option) => ({
                        label: option,
                        value: option,
                    }))}
                    value={value}
                    placeholder={optionalField.title ?? ''}
                    onChange={(value) => onChange(value)}
                />
            );

        case "number":
            return (
                <InputBase
                    type="number"
                    title={optionalField.title ?? ''}
                    inputProps={{ min: 0 }}
                    value={value}
                    onChange={(e) => onChange(Number(e.target.value))}
                />
            );

        default:
            return null;
    }
};